var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tree-wrap"},[_c('el-tree',{attrs:{"data":_vm.data,"indent":30,"highlight-current":true,"node-key":"id","expand-on-click-node":false,"render-content":_vm.renderContent,"default-expand-all":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }